export function AudioFillIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M19.993 3.12a1 1 0 00-1.31-1.069l-.229.077-.007.002-4.396 1.465A3 3 0 0012 6.441v8.35c-.85-.506-1.894-.791-3-.791-1.3 0-2.515.394-3.428 1.079C4.658 15.764 4 16.786 4 18c0 1.214.658 2.236 1.572 2.921C6.485 21.606 7.7 22 9 22c1.3 0 2.515-.394 3.428-1.079C13.342 20.236 14 19.214 14 18v-7.28l3.949-1.316A3 3 0 0020 6.559V3.25c0-.044-.002-.088-.007-.13z"
      ></path>
    </svg>
  );
}
